var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import OrganisationService from "../services/OrganisationService";
import { parseDate } from '@/common/utils/dateUtilities';
import { isValidIBAN, electronicFormatIBAN } from 'ibantools';
import moment from "moment";
import UserService from "../services/UserService";
export var withinRange = {
    params: ["min", "max"],
    validate: function (value, _a) {
        var min = _a.min, max = _a.max;
        var date = parseDate(value);
        if (!date)
            return true;
        var minDate = parseDate(min);
        var minOk = !minDate || minDate <= date;
        var maxDate = parseDate(max);
        var maxOk = !maxDate || maxDate >= date;
        return minOk && maxOk;
    }
};
export var earlierThanStrDate = {
    params: ["target"],
    validate: function (value, _a) {
        var target = _a.target;
        var valueDate = parseDate(value);
        if (!valueDate)
            return true;
        var targetDate = parseDate(target);
        if (!targetDate)
            return true;
        return valueDate <= targetDate;
    }
};
export var laterThanStrDate = {
    params: ["target"],
    validate: function (value, _a) {
        var target = _a.target;
        var valueDate = parseDate(value);
        if (!valueDate)
            return true;
        var targetDate = parseDate(target);
        if (!targetDate)
            return true;
        return valueDate >= targetDate;
    }
};
export var min_value = {
    params: ["target"],
    validate: function (value, _a) {
        var target = _a.target;
        var trimmed = value ? value.toString().replace(/\s/g, '').replace(/\,/g, '.') : '';
        var number = Number(trimmed);
        return number == null || number >= target;
    }
};
export var max_value = {
    params: ["target"],
    validate: function (value, _a) {
        var target = _a.target;
        var trimmed = value ? value.toString().replace(/\s/g, '').replace(/\,/g, '.') : '';
        var number = Number(trimmed);
        return number == null || number <= target;
    }
};
export var bothNotFalse = {
    params: ["target"],
    validate: function (value, _a) {
        var target = _a.target;
        if (value == null || target == null) {
            return true;
        }
        return (value || target);
    }
};
export var businessId = {
    validate: function (value) {
        var pattern = /^\d{7}-\d{1}$/;
        return pattern.test(value);
    }
};
export var businessIdExists = {
    validate: function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var organisationService;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    organisationService = new OrganisationService();
                    return [4 /*yield*/, organisationService.doesBusinessIdExist(value)];
                case 1: return [2 /*return*/, !(_a.sent())];
            }
        });
    }); }
};
export var organisationWithoutAdmin = {
    validate: function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var organisationService;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    organisationService = new OrganisationService();
                    return [4 /*yield*/, organisationService.organisationHasAdmin(value.id)];
                case 1: return [2 /*return*/, (_a.sent())];
            }
        });
    }); }
};
export var phone = {
    validate: function (value) {
        var pattern = /[^\d +-]/;
        return !pattern.test(value);
    }
};
export var postalCode = {
    validate: function (value) {
        var pattern = /^\d{5}$/;
        return pattern.test(value);
    }
};
export var name = {
    validate: function (value) {
        var pattern = /[\d@/\\´`""'()#¤$!%{[\]}?+,\.=¨~^*§:;|<>]/;
        return !pattern.test(value);
    }
};
export var organisationName = {
    validate: function (value) {
        var pattern = /^[a-zåäöA-ZÅÄÖ\d _\-()]+$/;
        return pattern.test(value);
    }
};
export var email = {
    validate: function (value) {
        var pattern = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]{2,4}$/;
        return pattern.test(value);
    }
};
export var emailIsNotTaken = {
    validate: function (value) {
        var userService = new UserService();
        return userService.emailIsNotTaken(value);
    }
};
export var realEstateId = {
    validate: function (value) {
        var pattern = /^(?=[\d-]{7,20}$)\d{1,}-\d{1,}-\d{1,}-\d{1,}$/;
        return pattern.test(value);
    }
};
export var shareGroupId = {
    validate: function (value) {
        var pattern = /^[a-zåäöA-ZÅÄÖ\d]{16}$/;
        return pattern.test(value);
    }
};
export var monthYearDate = {
    validate: function (value) {
        var pattern = /^\d{1,2}\.\d{4}$/;
        if (!pattern.test(value)) {
            return false;
        }
        ;
        var valueArray = value.split(".");
        return valueArray.length == 2 && moment(valueArray[1] + "-" + valueArray[0], "YYYY-MM").isValid();
    }
};
export var fullDate = {
    validate: function (value) {
        var pattern = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
        if (!pattern.test(value)) {
            return false;
        }
        ;
        var valueArray = value.split(".");
        return valueArray.length == 3 && moment(valueArray[2] + "-" + valueArray[1] + "-" + valueArray[0], "YYYY-MM-DD").isValid();
    }
};
export var iban = {
    validate: function (value) {
        var strippedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
        var strippedIban = electronicFormatIBAN(strippedValue);
        // Only finnish IBANs are valid.
        return strippedIban.startsWith("FI") && isValidIBAN(strippedIban);
    }
};
// Used to eliminate a specific case where option exists with id null AND name null. Everything else should pass.
export var notNullOption = {
    validate: function (value) {
        var option = value;
        return option.id !== null || option.name !== null;
    }
};
export var stringsMatchConfirm = {
    params: ["target"],
    validate: function (value, _a) {
        var target = _a.target;
        return value === target;
    }
};
// Password requirement 
// - At least 6 characters long
// - Must include at least one small and one capital letter
// - Must include at least one digit
// - Must include at least one special character
export var password = {
    validate: function (value) {
        var pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{6,}$/;
        return pattern.test(value);
    }
};
